// Adapted from https://jsfiddle.net/nq0hyz97/
/* eslint-disable */
var makeCodeRenderPre =
  makeCodeRenderPre ||
  (function () {
    // pre waiting to be rendered
    // when undefined, iframe is loaded and ready
    var pendingPres = []
    function injectRenderer() {
      var lang = document.getElementsByTagName('html')[0].lang
      var f = document.getElementById('makecoderenderer')
      // check iframe already added to the DOM
      if (f) {
        return
      }
      var f = document.createElement('iframe')
      f.id = 'makecoderenderer'
      f.style.position = 'absolute'
      f.style.left = 0
      f.style.bottom = 0
      f.style.width = '1px'
      f.style.height = '1px'
      f.src = `https://makecode.microbit.org/--docs?render=1&lang=${
        lang || 'en'
      }`
      document.body.appendChild(f)
    }

    function renderPre(pre) {
      if (!pre.id) pre.id = Math.random()
      var f = document.getElementById('makecoderenderer')
      // check if iframe is added and ready (pendingPres is undefined)
      if (!f || !!pendingPres) {
        // queue up
        pendingPres.push(pre)
        injectRenderer()
      } else {
        f.contentWindow.postMessage(
          {
            type: 'renderblocks',
            id: pre.id,
            code: pre.innerText,
            options: {
              package: ['datalogger=github:microsoft/pxt-microbit'],
            },
          },
          'https://makecode.microbit.org/'
        )
      }
    }

    // listen for messages
    window.addEventListener(
      'message',
      function (ev) {
        var msg = ev.data
        if (msg.source != 'makecode') return

        switch (msg.type) {
          case 'renderready':
            // flush pending requests
            var pres = pendingPres
            // set as undefined to notify that iframe is ready
            pendingPres = undefined
            pres.forEach(function (pre) {
              renderPre(pre)
            })
            break
          case 'renderblocks':
            var svg = msg.svg // this is an string containing SVG
            var id = msg.id // this is the id you sent

            var svgContainer = document.createElement('div')
            svgContainer.className = 'makecode-block'
            var parser = new DOMParser()
            var svgElement = parser.parseFromString(
              svg,
              'image/svg+xml'
            ).firstChild
            const svgStyle = svgElement.getElementsByTagName('style')[0]
            svgElement.removeChild(svgStyle)
            svgContainer.appendChild(svgElement)

            var code = document.getElementById(id)
            code.parentElement.insertBefore(svgContainer, code)
            code.parentElement.removeChild(code)
            break
        }
      },
      false
    )

    return renderPre
  })()

export function renderMakecodeBlocks() {
  let pres = document.getElementsByTagName('pre')
  Array.prototype.forEach.call(pres, function (pre) {
    if (pre.className === 'language-microbit') {
      makeCodeRenderPre(pre)
    }
  })
}
/* eslint-enable */
